import { memo, useEffect, useState } from "react";
import type { MenuProps } from "antd";
import { Dropdown, message } from "antd";
import {
  BellOutlined,
  UserOutlined,
  SettingOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { logoutCleanup } from "@/utils";
// import { logout } from '@/api'
import { useAppSelector } from "@/store";
import avatar from "@/assets/images/avatar.png";
import "./Nav.less";
import { getUserName } from "@/store/module/userInfo";

const items: MenuProps["items"] = [
  {
    key: "person",
    label: (
      <>
        <UserOutlined className="menu-item-icon" />
        个人中心
      </>
    ),
  },
  {
    key: "setting",
    label: (
      <>
        <SettingOutlined className="menu-item-icon" />
        个人设置
      </>
    ),
  },
  {
    key: "logout",
    label: (
      <>
        <LoginOutlined className="menu-item-icon" />
        退出登录
      </>
    ),
  },
];

function Nav() {
  const theme = useAppSelector((state) => state.theme);
 
  
  const [name, setName] = useState('')

  const onLogout = async () => {
    // 退出登陆
    // const res = await logout()
    // if (!res || res.code !== 0) return
    // message.success({
    //   content: '退出登录成功',
    //   duration: 1,
    //   onClose: () => {
    //     logoutCleanup()
    //   }
    // })
  };

  const onClick: MenuProps["onClick"] = ({ key }) => {
    if (key === "logout") {
      // onLogout()
    }
  };

  useEffect(() => {
    const userAccount =   localStorage.getItem("user-account");

    setName(userAccount as any)
  }, [])
  const loginOut = () => {
    logoutCleanup()
  }

  return (
    <div className="layout-nav">
      {/* <BellOutlined className="layout-header-icon" /> */}

      <span
          className="dropdown-link"
          style={{ height: theme.height, lineHeight: theme.height }}
        >
          <span className="dropdown-img-wrap">
            <img className="dropdown-img" src={avatar} />
          </span>
          <span className="dropdown-text">{name}</span>


          <span className="logout-btn" onClick={() => loginOut()}>退出</span>
        </span>

      {/* <Dropdown
        overlayClassName="layout-nav-dropdown"
        menu={{ items, onClick }}
      >
        <span
          className="dropdown-link"
          style={{ height: theme.height, lineHeight: theme.height }}
        >
          <span className="dropdown-img-wrap">
            <img className="dropdown-img" src={avatar} />
          </span>
          <span className="dropdown-text">君惜</span>


          <span className="dropdown-text">退出</span>
        </span>
      </Dropdown> */}
    </div>
  );
}

export default memo(Nav);
